/**
 * 오른쪽에 펼쳐지는 패널의 **제목줄 — 단일 정의.**
 *
 * SQL 실행이력 · 쿼리 챌린지 · AI 에이전트가 같은 레일에 선다(데이터 분석은 2026-10-28 작업 탭이 됐다).
 * 제목줄이 저마다 다르면 한 앱의 화면으로 안 읽힌다 — 실제로 패딩·아이콘 크기·닫기 버튼
 * 모양이 조금씩 달라 "일관되지 않다" 는 지적을 받았다(2026-09-20).
 *
 * 창(모달)의 제목줄이 `styles/appModal.css` 한 곳인 것과 같은 규칙이다. 패널마다 CSS 를
 * 또 만들지 말 것 — 지금까지 세 벌이었고 한 곳만 고치는 일이 반복됐다.
 *
 * 쓰는 법:
 *   <PanelHeader icon={<FiBarChart2 />} title={t('menu:edit.analysis')} onClose={onClose}>
 *     <button className="panel-header-action">…</button>   // 패널마다 다른 동작은 children 으로
 *   </PanelHeader>
 */
import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { FiX } from 'react-icons/fi';
import './PanelHeader.css';

function PanelHeader({ icon, title, children, onClose, closeTitle }) {
    const { t } = useTranslation();
    return (
        <div className="panel-header">
            {icon ? <span className="panel-header-icon">{icon}</span> : null}
            {/* 제목은 **양보하는 쪽**이다 — 자리가 모자라면 여기가 줄고 동작 버튼은 남는다 */}
            <span className="panel-header-title">{title}</span>
            {children}
            {onClose && (
                <button
                    type="button"
                    className="panel-header-close"
                    onClick={onClose}
                    title={closeTitle || t('common:ui.close')}
                    aria-label={closeTitle || t('common:ui.close')}
                >
                    <FiX size={14} />
                </button>
            )}
        </div>
    );
}

PanelHeader.propTypes = {
    icon: PropTypes.node,
    title: PropTypes.node.isRequired,
    /** 패널마다 다른 동작 버튼 — `panel-header-action` 클래스를 쓰면 모양이 맞는다 */
    children: PropTypes.node,
    onClose: PropTypes.func,
    closeTitle: PropTypes.string,
};

export default PanelHeader;
